const baseOrder = {
  // 订单状态
  'baseOrder.orderStatus': '订单状态',
  'baseOrder.orderStatus.placeholder': '请选择订单状态',
  'baseOrder.orderStatus.toBeConfirmed': '待确认',
  'baseOrder.orderStatus.confirmed': '已确认',
  'baseOrder.orderStatus.toBeShipped': '待发货',
  'baseOrder.orderStatus.partiallyShipped': '部分发货',
  'baseOrder.orderStatus.completed': '已完成',
  'baseOrder.orderStatus.cancelled': '已取消',

  // 发货状态
  'baseOrder.shipmentStatus': '发货状态',
  'baseOrder.shipmentStatus.placeholder': '请选择发货状态',
  'baseOrder.shipmentStatus.notShipped': '待发货',
  'baseOrder.shipmentStatus.partiallyShipped': '部分发货',
  'baseOrder.shipmentStatus.shipped': '已发货',
  'baseOrder.shipmentStatus.abnormalShipping': '异常发货',
  // 支付状态

  'baseOrder.paymentStatus': '支付状态',
  'baseOrder.paymentStatus.placeholder': '请选择支付状态',
  'baseOrder.paymentStatus.unpaid': '待支付',
  'baseOrder.paymentStatus.partiallyPaid': '部分支付',
  'baseOrder.paymentStatus.paid': '已支付',
  'baseOrder.paymentStatus.paymentException': '支付异常',

  'baseOrder.orderNumber': '订单号',
  'baseOrder.orderNumber.placeholder': '请输入订单号',
  'baseOrder.orderTime': '下单时间',

  'baseOrder.customerName': '客户名称',
  'baseOrder.skuTotal': 'SKU总数',
  'baseOrder.totalAmount': '货款',
  'baseOrder.fee': '费用',
};

export default baseOrder;
